interface SidebarIconProps {
  className: string;
}

export function CollapseSidebarIcon({ className }: SidebarIconProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
      <line className="sidebar-panel-divider" x1="15" y1="3" x2="15" y2="21" />
      <path className="sidebar-panel-arrow" d="m10 15-3-3 3-3" />
    </svg>
  );
}

export function ExpandSidebarIcon({ className }: SidebarIconProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect width="18" height="18" x="3" y="3" rx="2" ry="2" />
      <line className="sidebar-panel-divider" x1="15" y1="3" x2="15" y2="21" />
      <path className="sidebar-panel-arrow" d="m8 9 3 3-3 3" />
    </svg>
  );
}
